import { render, staticRenderFns } from "./PlanSettings.vue?vue&type=template&id=a5c929ca&scoped=true&"
import script from "./PlanSettings.vue?vue&type=script&lang=js&"
export * from "./PlanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c929ca",
  null
  
)

export default component.exports